import { mainReducer } from "./Reducers";
import { createStore, combineReducers } from "redux";

export const store = createStore(mainReducer);
